import { Theme } from "@material-ui/core/styles";
import COLORS from "../../../UI/Theme/colors";

const style: any = (theme: Theme): any => ({
	sideBarContainer: {
		width: 424,
		padding: "32px 40px",
		height: "calc(100% - 72px)",
		overflow: "auto",
	},
	closeButton: {
		position: "absolute" as const,
		right: 12,
		top: 12
	},
	sideBarTitle: {
		fontSize: 20,
		marginBottom: 20,
		fontWeight: theme.typography.fontWeightBold
	},
	filterButton: {
		border: "1px solid rgb(208, 213, 218)",
		backgroundColor: COLORS.WHITE,
		color: COLORS.DARK_GRAY,
		height: 38,
		marginLeft: "8px",
		padding: "7px 12px 8px 12px",
		Width: "160px",
		marginRight:"4px",
		fontWeight: theme.typography.fontWeightMedium,
		"&:hover": {
			border: "1px solid #868e96",
			backgroundColor: COLORS.WHITE,
		}
	},
	filterDot: {
		fontSize: "2.2rem",
		margin: "0 0.2rem",
		paddingBottom: "0.1rem"
	},
	actionContainer: {
		position: "absolute" as const,
		bottom: 0,
		height: 72,
		width: 424,
		padding: "0px 40px",
		display: "flex",
		alignItems: "center" as const,
		justifyContent: "flex-end",
		backgroundColor: COLORS.WHITE
	},
	resetBtn: {
		position: "absolute" as const,
		left: 34,
		bottom: 31,
		top:20,
		width: "39px",
		height: "21px",
		paddingLeft: 0,
		margin: "8px 244px 7px 0",
        fontSize: "14px",
		fontWeight: "500",
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "1.5",
		letterSpacing: "normal",
		color: "#005fbe"
	}
});

export default style;